import * as Types from '../generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type OfferEventSuggestionsMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  identifiers: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;

export type OfferEventSuggestionsMutation = {
  __typename?: 'Mutation';
  offerEventSuggestions: Array<{
    __typename?: 'EventSuggestion';
    id: string;
    identifier: string;
    stateJSON?: any | null;
    createdAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    offeredAt?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
  }>;
};

export type UpdateEventSuggestionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  payload: Types.UpdateEventSuggestionPayload;
}>;

export type UpdateEventSuggestionMutation = {
  __typename?: 'Mutation';
  updateEventSuggestion: {
    __typename?: 'EventSuggestion';
    id: string;
    identifier: string;
    stateJSON?: any | null;
    createdAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    offeredAt?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
  };
};

export const OfferEventSuggestionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OfferEventSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identifiers' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offerEventSuggestions' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'identifiers' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identifiers' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventSuggestion' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventSuggestion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSuggestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offeredAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'stateJSON' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type OfferEventSuggestionsMutationFn = Apollo.MutationFunction<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>;

/**
 * __useOfferEventSuggestionsMutation__
 *
 * To run a mutation, you first call `useOfferEventSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferEventSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerEventSuggestionsMutation, { data, loading, error }] = useOfferEventSuggestionsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      identifiers: // value for 'identifiers'
 *   },
 * });
 */
export function useOfferEventSuggestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>) {
  return ApolloReactHooks.useMutation<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>(OfferEventSuggestionsDocument, baseOptions);
}
export type OfferEventSuggestionsMutationHookResult = ReturnType<typeof useOfferEventSuggestionsMutation>;
export type OfferEventSuggestionsMutationResult = Apollo.MutationResult<OfferEventSuggestionsMutation>;
export type OfferEventSuggestionsMutationOptions = Apollo.BaseMutationOptions<OfferEventSuggestionsMutation, OfferEventSuggestionsMutationVariables>;
export const UpdateEventSuggestionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventSuggestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventSuggestionPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventSuggestion' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventSuggestion' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventSuggestion' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSuggestion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'offeredAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'stateJSON' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventSuggestionMutationFn = Apollo.MutationFunction<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>;

/**
 * __useUpdateEventSuggestionMutation__
 *
 * To run a mutation, you first call `useUpdateEventSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSuggestionMutation, { data, loading, error }] = useUpdateEventSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventSuggestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>(UpdateEventSuggestionDocument, baseOptions);
}
export type UpdateEventSuggestionMutationHookResult = ReturnType<typeof useUpdateEventSuggestionMutation>;
export type UpdateEventSuggestionMutationResult = Apollo.MutationResult<UpdateEventSuggestionMutation>;
export type UpdateEventSuggestionMutationOptions = Apollo.BaseMutationOptions<UpdateEventSuggestionMutation, UpdateEventSuggestionMutationVariables>;
